export const hidePhoneNumber = (phone: string): string => {
  if (phone && phone.startsWith("+") && phone.length > 10) {
    return phone.slice(0, 5) + "*****" + phone.slice(-2);
  }
  return "+7********";
};
